import React, { useState, useEffect, useCallback } from "react";
import keycloak from "./keycloak";
import { KeycloakContext } from "./KeycloakContext";

export const KeycloakProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [token, setToken] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const redirectUri = useCallback(
    () => window.location.origin + window.location.pathname,
    []
  );

  useEffect(() => {
    if (keycloak.didInitialize) return;
    keycloak
      .init({
        onLoad: "login-required",
        pkceMethod: "S256",
        responseMode: "query",
        redirectUri: redirectUri(),
      })
      .then((auth) => {
        setAuthenticated(auth);
        setInitialized(true);
        if (auth) {
          setToken(keycloak.token);
          setUserInfo(keycloak.tokenParsed);
          keycloak.loadUserInfo().then((info) => {
            setUserInfo(info);
          });
        }
      })
      .catch((err) => {
        console.error("Keycloak init failed:", err);
        setInitialized(true);
      });
  }, []);

  const login = useCallback(() => {
    keycloak.login({
      redirectUri: redirectUri(),
    });
  }, [redirectUri]);

  const logout = useCallback(() => {
    keycloak.logout({
      redirectUri: redirectUri(),
    });
  }, [redirectUri]);

  const updateToken = useCallback(() => {
    keycloak
      .updateToken(60)
      .then((refreshed) => {
        if (refreshed) {
          setToken(keycloak.token);
        }
      })
      .catch(() => {
        setAuthenticated(false);
        login();
      });
  }, [login]);

  useEffect(() => {
    if (!authenticated) return;
    const interval = setInterval(() => {
      updateToken();
    }, 60000);
    return () => clearInterval(interval);
  }, [authenticated, updateToken]);

  const value = {
    keycloak,
    authenticated,
    initialized,
    token,
    userInfo,
    login,
    logout,
    updateToken,
  };

  return (
    <KeycloakContext.Provider value={value}>
      {children}
    </KeycloakContext.Provider>
  );
};

export default KeycloakProvider;
